import { isString, isObject } from "@mcwd/typescript-type-guards";
import { SiteLocale, type CountryLocale, type ExtendedLocaleCountry } from "../../../types-and-definitions/locale-defs/Locales.js";

export function getSiteLangFromOtGeoQuerystring ()
{
  let otgeo = (new URLSearchParams(window.location.search)).get("otgeo");
  if (isString(otgeo))
  {
    otgeo = (otgeo.toLowerCase() === "uk" ? "gb" : otgeo);
    let sLocale = SiteLocale.getByCountryLocale(otgeo as CountryLocale);
    sLocale ??= SiteLocale.getByExtendedCountryLocale(otgeo as ExtendedLocaleCountry);
    if (isObject(sLocale))
    {
      return sLocale.LanguageCountryLocale;
    }
  }
  return null;
}
